import React from "react";
import { Link } from "react-router-dom";

const TwoButtons = ({
  buttonHead1,
  buttonHead2,
  noUrl = false,
  LinkURL,
  onClick1,
  onClick2,
}) => {
  return (
    <div className="flex-end" style={{ margin: "20px 0px" }}>
      {noUrl ? (
        <Link to={`${LinkURL}`}>
          <button onClick={onClick1} className="button-class-white">
            {buttonHead1}
          </button>
        </Link>
      ) : (
        <button onClick={onClick1} className="button-class-white">
          {buttonHead1}
        </button>
      )}
      <button onClick={onClick2} type="submit" className="button-class">
        {buttonHead2}
      </button>
    </div>
  );
};

export default TwoButtons;
